import { gql } from '@apollo/client';

export const PROPERTY_BID_FRAGMENT = gql`
  fragment PropertyBid on Property {
    bid {
      link {
        url
      }
    }
  }
`;
